// eslint-disable-next-line no-use-before-define
import React from 'react';
export const Link = ({ children, href, callback, className }) => {
    const onClickHandler = (event) => {
        if (event.ctrlKey) {
            return;
        }
        if (event.button !== 1 && callback) {
            event.preventDefault();
            callback(href);
        }
    };
    return (React.createElement("a", { className: className ? className : '', href: href, onClick: onClickHandler },
        React.createElement("span", null, children)));
};
//# sourceMappingURL=index.js.map